import { useCallback } from 'react';
import { identity, memoizeWith, toString } from 'ramda';

import { useGetTriggerCondition } from './useGetTriggerCondition';

const getMemoizedCondition = memoizeWith(condition => toString(condition), identity);

export const useTriggerCondition = () => {
    const triggerCondition = useGetTriggerCondition();

    return useCallback((condition) => {
        const memoCondition = getMemoizedCondition(condition);

        triggerCondition(memoCondition);
    }, [triggerCondition]);
};
